export const WidgetLangMap = {
  Ru: 0,
  En: 1
} as const
